<template>
  <div class="pr-2.5 pl-6 py-1 mb-1 my-0 text-bg-700 text-sm">
    <div v-if="!addingFolder"
      class="flex items-baseline ml-2.5 mt-2 w-full text-gray-500 cursor-pointer group hover:text-gray-900"
      @click.stop="toggleFolderForm"
    >
      <span class="mr-3">
        <svg class="fill-current" width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg"><path d="M11 6H6L6 11H5V6H0V5H5V0H6L6 5H11V6Z"/></svg>
      </span>
      <span class="pb-px border-b border-transparent transition-all group-hover:border-black">Add Folder</span>
    </div>
    <form
      v-else
      class="mr-1.5 ml-2.5"
      @submit.prevent="createNewFolder"
      @keyup.esc="toggleFolderForm"
    >
      <div @click.stop>
        <input placeholder="Folder Name" class="py-2 px-3 mt-1 mb-2 w-full rounded border border-gray-300 focus:outline-none focus:border-gray-700" ref="title" v-model="folderTitle" type="text"/>
      </div>
      <div class="flex">
        <button class="flex-1 mr-2 text-sm btn outline" @click.stop="toggleFolderForm">Cancel</button>
        <button class="flex-1 text-sm btn" submit="btn" @click.stop>Create</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addingFolder: false,
      folderTitle: ''
    }
  },
  methods: {
    toggleFolderForm() {
      if (this.addingFolder) { this.folderTitle = '' }
      this.addingFolder = !this.addingFolder
      this.$nextTick(() => this.$refs.title.focus())
    },
    createNewFolder() {
      if (this.folderTitle) {
        const { Folder } = this.$FeathersVuex.api
        const folder = new Folder({ title: this.folderTitle })
        folder.save().then(() => {
          this.folderTitle = ''
        }).catch(err => {
          alert(err.message)
        })
      }
    }
  }
}
</script>
